import React from "react";
import { Grid, Avatar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { useSelector } from "react-redux";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    comment: {
        width: "100%",
        padding: 5,
        backgroundColor: "white",
        border: "gainsboro 1px solid",
        borderRadius: 5,
        marginBottom: 15,
    },
    editing: {
        backgroundColor: "#eaecf7",
    },
    avatar: {
        width: 26,
        height: 26,
        fontSize: "1rem",
    },
    userAndDateContainer: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
    },
    author: { margin: 0, textAlign: "left", fontWeight: 500 },
    commentDate: {
        fontSize: "0.6rem",
        color: "gray",
        margin: 0,
        marginLeft: 20,
        fontWeight: 100,
    },
    commentText: {
        textAlign: "left",
        fontWeight: 100,
        fontSize: "0.75rem",
    },
    action: {
        width: "24px",
        height: "24px",
        padding: 0,
        minWidth: "24px",
        minHeight: "24px",
        marginTop: 10,
    },
    actionIcon: {
        marginLeft: "8px",
    },
    actionsContainer: {
        display: "flex",
        flexDirection: "column",
    },
}));

export default function Comment({ comment, resources, onEdit, inEdition, onDelete }) {
    const classes = useStyles();
    const { user } = useSelector((state) => state.Login);

    function getUserFullName(userId) {
        const usr = resources && resources.users && resources.users.find((x) => x.id === userId);
        return usr ? usr.name : "**Unknown user**";
    }

    function onEditHandler() {
        onEdit(comment);
    }

    function onDeleteHandler() {
        onDelete(comment);
    }

    const userFullName = getUserFullName(comment.userId);

    return (
        <>
            <Grid container wrap="nowrap" spacing={2} className={clsx(classes.comment, { [classes.editing]: inEdition })}>
                <Grid item>
                    <Avatar className={classes.avatar}>{userFullName.trim().charAt(0).toUpperCase()}</Avatar>
                    {comment.userId === user.id && (
                        <div className={classes.actionsContainer}>
                            <Button
                                title="Edit comment"
                                color="primary"
                                startIcon={<EditIcon className={classes.actionIcon} />}
                                onClick={onEditHandler}
                                variant="text"
                                size="small"
                                className={classes.action}
                            >
                                {""}
                            </Button>
                            <Button
                                title="Delete comment"
                                color="secondary"
                                startIcon={<DeleteIcon className={classes.actionIcon} />}
                                onClick={onDeleteHandler}
                                variant="text"
                                size="small"
                                className={classes.action}
                            >
                                {""}
                            </Button>
                        </div>
                    )}
                </Grid>
                <Grid item xs zeroMinWidth>
                    <div className={classes.userAndDateContainer}>
                        <h4 className={classes.author}>{userFullName}</h4>
                        <h4 className={classes.commentDate}>{comment.dateString}</h4>
                    </div>
                    <p className={classes.commentText}>{comment.comment} </p>
                </Grid>
            </Grid>
        </>
    );
}
